import styled from 'styled-components'
import { sizes } from '../../util'

export const Wrapper = styled.div`
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '100rem')};
  /* margin: ${({ width }) => (width === 'full' ? '0 auto' : '1rem')}; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: ${({ bg }) => bg || 'transparent'};

  @media (min-width: ${sizes.medium}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 4rem')};
  }
`

export const Box = styled.div`
  width: 100%;
  background: white;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '44rem')};
  color: ${({ theme }) => theme.colorText};
  align-self: ${({ align }) => align};
  ${({ shadow }) => shadow && 'box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);'}
`

export const Text = styled.p`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '1.5rem')};
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem' : '2rem 4rem 4rem')};
  ${({ align }) => align && `text-align: ${align}`}
  bold {
    font-weight: 600;
  }
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '1.75rem' : '1.25rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem' : '2rem 2rem 2rem')};
  }
  @media (max-width: ${sizes.small}) {
    font-size: ${({ size }) => (size === 'big' ? '1.5rem' : '1rem')};
  }
`

export const Tag = styled.p`
  font-size: 4rem;
  line-height: 1.1;
  padding: 3rem 4rem 0;
  font-weight: 300;
  @media (max-width: ${sizes.medium}) {
    font-size: 3.5rem;
    padding: 3rem 2rem 0;
  }
  @media (max-width: ${sizes.small}) {
    font-size: 2.5rem;
  }
`

export const Top = styled.div`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  border-bottom: 1px solid;
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '2rem' : '0.75rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
`
